import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { ListData } from './types'

export const selectMerchantTypeListEvent = (state: RootState): Event =>
  state.manageMerchantTypeReducer.listEvent

export const selectMerchantTypeList = (state: RootState): ListData => state.manageMerchantTypeReducer.list

export const selectMerchantTypeActionEvent = (state: RootState): Event =>
  state.manageMerchantTypeReducer.actionEvent
